import { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { actions } from 'forms/rrf';
import PageTitle from '../../common/page-title';
import { getTeamOutlet } from '../../../actions/outlet';
import OutletDetails from '../../common/outlet/outlet-details';
import Divider from '../../common/divider';
import StaffMemberList from '../../common/outlet/staff-member-list';
import TeamRewardDetails from './team-reward-details';
import ArrowButton from '../../common/button-arrow';
import { doPseudoLoginRep } from '../../../actions/users';
import { sendStoreMessage } from '../../../actions/messages';
import MessageDialog from '../my-stores/message-dialog';
import Can from '../../common/guards/can';
import { history } from '../../../store';
import { isPseudoLoggedIn } from '../../../utils/tokenUtils';

import './style.css';

class StoreDetails extends Component {
  state = {
    showMessageDialog: false
  };

  handleStoreDemoClick = (userId) => {
    doPseudoLoginRep(userId);
  };

  openMessageModal = () => {
    try {
      this.setState({
        showMessageDialog: true
      }, () => {
        this.props.dispatch(actions.reset('deep.store_message'));
      });
    } catch (error) { //
      // swallowed modal lib bug error
    }
  };

  handleMessageClose = () => {
    this.setState({
      showMessageDialog: false
    });
  };

  handleMessageSend = (payload) => {
    const { dispatch, store } = this.props;

    const message = {
      ...payload,
      outlet_id: store.id,
    };

    dispatch(sendStoreMessage(message))
      .then(() => {
        dispatch(actions.reset('deep.store_message'));
        this.handleMessageClose();
      });
  };

  UNSAFE_componentWillMount() {
    const { dispatch, match } = this.props;

    dispatch(getTeamOutlet(match.params.id));
  }

  render() {
    const { fetched, store, staffMembers } = this.props;
    const { showMessageDialog } = this.state;

    return (fetched && (
      <Container fluid className="details">
        <Row>
          <Col lg={12}>
            <Button variant='link' className='back-link' onClick={() => history.back()}>
              Back
            </Button>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>
              View Outlet
            </PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            {store.attributes.owner.id && !isPseudoLoggedIn() && (
              <ArrowButton
                className="float-right"
                arrow={false}
                submit={false}
                onClick={() => this.handleStoreDemoClick(store.attributes.owner.id)}
              >
                Store Demo
              </ArrowButton>
            )}
            <h3>
              Outlet details
            </h3>
            <OutletDetails id={store.id} details={store.attributes}/>
            <Can action="view" subjectClass="messages_rep_area">
              {store.attributes.owner.id && (
                <ArrowButton
                  arrow={false}
                  submit={false}
                  onClick={() => this.openMessageModal()}
                >
                  Send a message
                </ArrowButton>
             )}
            </Can>
            <Divider/>
          </Col>
        </Row>
        <Can action="show" subjectClass="rewards_details_rep_area">
          {store.attributes['reward-store'] && (
            <Row>
              <Col lg={12}>
                <h3>
                  Reward details
                </h3>
                <TeamRewardDetails store={store}/>
                <Divider/>
              </Col>
            </Row>
          )}
        </Can>
        <Can action="view" subjectClass="staff_rep_area">
          <Row>
            <Col lg={12}>
              <h3>
                Staff details
              </h3>
              <StaffMemberList
                owner={store.attributes.owner}
                staffMembers={staffMembers}
              />
            </Col>
          </Row>
        </Can>
        {showMessageDialog && (
          <MessageDialog
            onClose={this.handleMessageClose}
            onMessageSend={payLoad => this.handleMessageSend(payLoad)}
            to={`${store.attributes.owner.name}-${store.attributes.name}-${store.id}`}
          />
        )}
      </Container>
    ));
  }
}

const mapStateToProps = state => ({
  store: state.teamStoreDetail.store,
  staffMembers: state.teamStoreDetail.staff_members,
  fetching: state.teamStoreDetail.fetching,
  fetched: state.teamStoreDetail.fetched,
});

export default connect(mapStateToProps)(StoreDetails);
